module.exports = __webpack_public_path__ + "static/media/Vendas4.397dd271.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancVendas/Vendas4.png
// module id = 1775
// module chunks = 0